import {useEffect, useState} from "react";
import Validator from "../Validator";

function Radio({title, initialError, id, required, value, setValue, updateObject, options}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function handleChange(event) {
        if (typeof setValue === "function") {
            setValue(event.target.value);
        }

        validate(event.target.value);

        if (typeof updateObject === "function") {
            updateObject(id, event.target.value);
        }
    }

    function validate(option) {
        setError(Validator.validateField(option, id, required, "radio"));
    }

    return (
        <>
            <div className="text-primary -mb-2">
                {title}{required ? "*" : ""} :
            </div>
            <div className="flex justify-between">
                {options.map((option, index) => (
                    <div key={index} className="flex items-center pl-4">
                        <input checked={value === option.value} id={id + "-" + index} type="radio" value={option.value}
                               name={id} onChange={handleChange} onBlur={updateObject} className="indeterminate:red-500"
                        />
                        <label htmlFor={id + "-" + index}
                               className={"w-full py-4 ml-2 text-sm font-medium " + (error ? "text-red-600" : "text-primary")}>{option.label}</label>
                    </div>
                ))}
            </div>
            {error ?
                (
                    <p className="mt-0 text-xs text-red-600 font-medium">{error}</p>
                )
                : ""}
        </>
    );
}

export default Radio;